import { useTranslation } from 'react-i18next';
import { ReactComponent as SadEmoji } from '../../../assets/sad-emoji.svg';
import styles from './GlobalErrorPlug.module.scss';

export default function GlobalErrorPlug(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <SadEmoji className={styles.icon} />
      <p className={styles.text}>{t('global_error')}</p>
    </div>
  );
}
